import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button, Card, Badge } from 'react-bootstrap';
import ReactPlayer from "react-player";
import cameraImgLg from "../../../common/images/cameraImgLg.jpg";
import cameraImgSt from "../../../common/images/imgShrt.jpg";

import { CameraModalPopup } from "./CameraModalPopup";

import HlsPlayer from "./HlsPlayer";

const canLoadInIframe = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

const canLoadRTSP = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return parsed.protocol === "rtsp:";
  } catch {
    return false;
  }
};

const CameraListView = ({ cameraData={} }) => {

  const [showDetails, setShowDetails] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => { 

    if(cameraData && Object.keys(cameraData).length > 0) {
       setSelectedCamera(cameraData[0]);
    }

  }, [cameraData])

  const handleMouseDown = (e) => {
    if (!scrollContainerRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
    // Add pointer-events: none to prevent image dragging
    scrollContainerRef.current.style.scrollBehavior = 'auto';
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (scrollContainerRef.current) {
      scrollContainerRef.current.style.scrollBehavior = 'smooth';
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !scrollContainerRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // Adjusted scroll speed multiplier
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleViewDetail = (rowDetails) => {
        setRowData(rowDetails);
        setShowDetails(true);
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleSelectedCamera = (sltCamera) => {
        console.log('sltCamera', sltCamera);
        setSelectedCamera(sltCamera);
  }

  const loadWebcamFun = (camera) => {
         
         if(canLoadRTSP(camera?.streamingUrl) && canLoadInIframe(camera?.convertedStreamingUrl)) {
            return (<HlsPlayer streamingurl={camera.convertedStreamingUrl} />);
         } else if(canLoadInIframe(camera?.streamingUrl)) {
              return (<iframe
              src={camera?.streamingUrl}
              title={camera?.name}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />);
         } else {
            return (<div className="unsupported-stream">
                    Unsupported Stream Type
                  </div>);
         }
  }

  return (<Container fluid className="camera-container">
          {(cameraData) && <>
            <Row className="g-3 mb-3">
              <Col xs={12}>
                <Card className="camera-card featured">
                  <div className="camera-image-wrapper">
                    <div className="camera-iframe-wrapper">
                      {loadWebcamFun(selectedCamera)}
                    </div>
                    <Badge bg="danger" className="live-badge">
                      <span className="live-indicator"></span>
                      LIVE RECORDING
                    </Badge>
                    <div className="camera-overlay">
                      <div className="camera-info">
                        <div className="camera-name">{selectedCamera?.name} {(selectedCamera?.category === 'in')?<span>(IN Camera)</span>:<span>(OUT Camera)</span>}</div>
                        <div className="camera-location">{selectedCamera?.model}</div>
                      </div>
                      <div className="camera-menu" onClick={() => handleViewDetail(selectedCamera)}>⋮</div>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>

            <div 
              className="horizontal-scroll-container"
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              <div className="horizontal-scroll-content">
                {cameraData.map((camera) => (
                  <div key={camera.id} className="horizontal-camera-item">
                    <Card className="camera-card">
                      <div className="camera-image-wrapper">
                        <div className="camera-iframe-wrapper" onClick={() => handleSelectedCamera(camera)}>
                          {loadWebcamFun(camera)}
                        </div>
                        <Badge bg="danger" className="live-badge">
                          <span className="live-indicator"></span> LIVE RECORDING
                        </Badge>
                        <div className="camera-overlay">
                          <div className="camera-info">
                            <div className="camera-name">{camera.name}</div>
                            <div className="camera-location">{camera.model}</div>
                          </div>
                          <div className="camera-menu" onClick={() => handleViewDetail(camera)}>⋮</div>
                        </div>
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
            </>}
      
      <CameraModalPopup
          show={showDetails}
          onHide={handleDetailCancel}
          resultdata={rowData}
      />

  </Container>);
};

export default CameraListView;
